import { initApi as initApiAuth } from '@/lib/api-gluglu-auth'
import { initApi as initApiOpen } from '@/lib/api-gluglu-open'
import { TENANTS } from '@/lib/tenants/constants'

export function useExpressPotentialPropertyVisitInterest(
  transactionId: string
): (params: VisitInterest) => Promise<void> {
  return (params) => {
    switch (params.tenant) {
      case TENANTS.casavo:
        return sendCasavoVisitInterest(transactionId, params.args)
      case TENANTS.ucsc:
        return sendUCSCVisitInterest(transactionId, params.args)
    }
  }
}

export type CasavoVisitInterest = {
  buyerPhoneNumber: string
  name: string
} & (
  | {
      email?: undefined
      isLogged: true
    }
  | {
      crmContactId: string
      email: string
      isLogged: false
      score: string
    }
)

type UCSCVisitInterest = {
  contactId: string
}

export type VisitInterest =
  | {
      args: CasavoVisitInterest
      tenant: typeof TENANTS.casavo
    }
  | {
      args: UCSCVisitInterest
      tenant: typeof TENANTS.ucsc
    }

async function sendCasavoVisitInterest(transactionId: string, args: CasavoVisitInterest) {
  if (args.isLogged === false) {
    await initApiOpen().potentialPropertyVisitInterest(transactionId, {
      crm_contact_id: args.crmContactId,
      email: args.email,
      name: args.name,
      phone: args.buyerPhoneNumber,
      score: args.score,
      tenant_id: TENANTS.casavo,
    })
  } else {
    await initApiAuth().potentialPropertyVisitInterest(transactionId, {
      name: args.name,
      phone: args.buyerPhoneNumber,
    })
  }
}

async function sendUCSCVisitInterest(transactionId: string, { contactId }: UCSCVisitInterest) {
  await initApiOpen().potentialPropertyVisitInterest(transactionId, {
    contact_id: contactId,
    tenant_id: TENANTS.ucsc,
  })
}
